import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, decimals = 2) {
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(value);
}

export function formatNumber(value, decimals = 2) {
  return Number(value).toFixed(decimals);
}

export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function formatDateTime(date) {
  return new Date(date).toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function getRiskColor(riskFlag) {
  switch (riskFlag) {
    case 'HIGH':
      return 'text-red-500';
    case 'MEDIUM':
      return 'text-amber-500';
    default:
      return 'text-emerald-500';
  }
}

export function getSeverityColor(severity) {
  switch (severity) {
    case 'HIGH':
      return 'bg-red-500/10 text-red-500 border-red-500/20';
    case 'MEDIUM':
      return 'bg-amber-500/10 text-amber-500 border-amber-500/20';
    case 'LOW':
      return 'bg-blue-500/10 text-blue-500 border-blue-500/20';
    default:
      return 'bg-zinc-500/10 text-zinc-500 border-zinc-500/20';
  }
}
